import React from "react";
import "../css/privacy.scss";

function Faqs() {
  const items = [
    ["How should I choose a tea or coffee?", "Start with the flavor notes on each product page. If you prefer a lighter cup, look for floral, citrus, or fresh-green notes. For a fuller cup, look for cocoa, caramel, spice, or dark-roast notes."],
    ["Are brewing instructions included?", "Yes. Tea listings include a suggested amount, water temperature, and steep time. Coffee bags include preparation guidance, and you can select an available grind before adding coffee to your cart."],
    ["How should I store tea and coffee?", "Keep products sealed in a cool, dry place away from sunlight, moisture, heat, and strong aromas. For the freshest flavor, use them within a reasonable period after opening."],
    ["Do teas contain caffeine?", "Black and green teas naturally contain caffeine. Herbal tisanes are generally caffeine-free unless the ingredient list says otherwise. Caffeine levels vary with leaf, amount, water temperature, and steep time."],
    ["Can I change or cancel an order?", "Contact us as soon as possible at steps@tugglefield.xyz. We will try to help before fulfillment begins, but changes are not guaranteed once an order is being prepared or shipped."],
    ["Where do you ship?", "Availability, rates, and estimated delivery times are shown in our Shipping Policy and during checkout. International availability may vary by destination."],
    ["What is your return window?", "Eligible unused items may be returned within 30 days, subject to the conditions in our Refund Policy. Sealed consumable products must remain unopened."],
    ["How can I contact tugglefield?", "Email steps@tugglefield.xyz with your question or order number."],
  ];

  return (
    <main className="layout--template" id="main_content">
      <div className="shopify-policy__container">
        <div className="shopify-policy__title"><h1>Frequently Asked Questions</h1></div>
        <div className="shopify-policy__body">
          <div className="rte">
            {items.map(([question, answer]) => (
              <section key={question}>
                <p><strong>{question}</strong><br />{answer}</p>
              </section>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
}

export default Faqs;
